<template>
  <v-dialog v-model="dialog" width="400px">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title>Configurar sincronização de contatos</v-list-item-title>
      </v-list-item>
    </template>
    <v-card min-height="250">
      <v-card-title>
        <span class="table-card-title pl-0">Sincronização de contatos (BETA)</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col class="pt-0">
            <span
              >Esta é uma feature teste, apenas disponível para usuários da Mercafacil, para que seja configurado e-mails do Gmail onde contatos que enviarem
              mensagens nos bots serão inseridos.</span
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center" class="pt-0">
            <google-login-button
              :client-id="clientId"
              :scopes="['https://www.googleapis.com/auth/contacts', 'https://www.googleapis.com/auth/userinfo.email']"
              @onError="onSignInError"
              @onSuccess="onSignInSuccess"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-5">
        <mf-action-buttons
          :primary-button="{
            text: 'Salvar',
            action: submit,
            isDisabled: !authCode,
            isLoading: loading,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATION_SET_WAPP_CONTACTS_SYNC_AUTHENTICATION } from '@/modules/campanhas/whatsapp/graphql/index.js'

export default {
  components: {
    GoogleLoginButton: () => import('@/components/GoogleLoginButton.vue'),
  },
  props: {
    registerId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    clientId: '175070942227-7cjbst0v8uuf6cpm98r4hsfii1r3fs3d.apps.googleusercontent.com',
    authCode: '',
    redirectUri: '',
    loading: false,
    dialog: false,
  }),
  watch: {
    dialog() {
      this.authCode = ''
      this.redirectUri = ''
    },
  },
  methods: {
    async onSignInSuccess({ authCode, redirectUri }) {
      this.authCode = authCode
      this.redirectUri = redirectUri
    },
    onSignInError() {
      this.$snackbar({
        text: 'Falha ao logar com Google ou você não tem permissão de acesso.',
        type: 'error',
      })
    },
    async submit() {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_SET_WAPP_CONTACTS_SYNC_AUTHENTICATION,
          variables: {
            authCode: this.authCode,
            redirectUri: this.redirectUri,
            registerId: this.registerId,
          },
        })
        this.loading = false
        this.dialog = false
        this.$emit('refresh')
      } catch (e) {
        console.warn(e)
        this.$snackbar({
          text: 'Falha ao salvar autenticação',
          type: 'error',
        })
        this.loading = false
      }
    },
    cancel() {
      this.dialog = false
    },
  },
}
</script>
